import ResizeObserver from "resize-observer-polyfill/dist/ResizeObserver.global";

export default () => {
    //console.log('resize-observer-ployfill loaded?');
};
